import * as Loglevel from 'loglevel'; //https://github.com/pimterry/loglevel

// declare module 'loglevel' {
//     interface LogLevel {
//         [key: string]: number;
//     }
// }

declare module '@/environment' {
    interface Environment {
        features: string[];
    }
}

import environment, { Features } from '@/environment';
import services from '@/services';

class Env {
    name = process.env.NODE_ENV;
    features = Features;
    currentFeatures: any = [];
    services: any = services;
    log = <Loglevel.Logger>null;

    constructor() {
        // @ts-ignore
        this.currentFeatures = environment.features;

        this.log = Loglevel.getLogger('main');
        this.log.setLevel(this.isDevelopment ? Loglevel.levels.DEBUG : Loglevel.levels.WARN);

        this.log.info(`Environment`, this.name);
        this.log.info('Enabled features', this.currentFeatures);

        // if (this.hasFeature(this.features.CORDOVA) && !window.cordova) {
        // 	throw new Error(`Not in cordova environment: ${this.name}, Build project via cordova`);
        // }
    }

    toString() {
        return process.env.NODE_ENV;
    }

    hasFeature(name: string): boolean {
        return this.currentFeatures.includes(name);
    }

    get isProduction() {
        return process.env.NODE_ENV === 'production';
    }
    set isProduction(p) {}

    get isDevelopment() {
        return process.env.NODE_ENV !== 'production';
    }
    set isDevelopment(p) {}
}

const env = new Env();

export default env;
